import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, Renderer2, ViewChild } from "@angular/core";
import { BaseControlComponent } from "../base/base-control.component";
import { NgModel } from "@angular/forms";

import { Moment } from "jalali-moment";
import { IDatePickerConfig, ECalendarValue } from "projects/persian-date-picker/src/lib";
import { SelectorService } from "../base/selector.service";

import * as moment from "jalali-moment";
@Component({
  //moduleId: module.id,
  selector: "date-picker",
  templateUrl: "date-picker.template.html",
  styleUrls: ["date-picker.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatePickerComponent extends BaseControlComponent<string> {
  @ViewChild(NgModel, { static: false }) model: NgModel;
  displayDate: Moment | string;
  validationMinDate: Moment;
  validationMaxDate: Moment;
  @Input() mode: string = "time";
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private renderer: Renderer2, private elRef: ElementRef) {
    super(selectorService, cd);
  }
  jalaliConfigExtension: IDatePickerConfig = {
    firstDayOfWeek: "sa",
    monthFormat: "MMMM YYYY",
    weekDayFormat: "dd",
    dayBtnFormat: "D",
    monthBtnFormat: "MMMM",
    locale: "fa",
  };
  gregorianSystemDefaults: IDatePickerConfig = {
    firstDayOfWeek: "su",
    monthFormat: "MMM, YYYY",
    disableKeypress: false,
    allowMultiSelect: false,
    closeOnSelect: undefined,
    closeOnSelectDelay: 100,
    openOnFocus: true,
    openOnClick: true,
    onOpenDelay: 0,
    weekDayFormat: "ddd",
    appendTo: document.body,
    showNearMonthDays: true,
    showWeekNumbers: false,
    enableMonthSelector: true,
    yearFormat: "YYYY",
    showGoToCurrent: true,
    dayBtnFormat: "DD",
    monthBtnFormat: "MMM",
    hours12Format: "hh",
    hours24Format: "HH",
    meridiemFormat: "A",
    minutesFormat: "mm",
    minutesInterval: 1,
    secondsFormat: "ss",
    secondsInterval: 1,
    showSeconds: false,
    showTwentyFourHours: false,
    timeSeparator: ":",
    multipleYearsNavigateBy: 10,
    showMultipleYearsNavigation: false,
    locale: "en",
    hideInputContainer: false,
    returnedValueType: ECalendarValue.String,
    unSelectOnClick: true,
    hideOnOutsideClick: true,
  };

  config: IDatePickerConfig = { ...this.gregorianSystemDefaults, ...this.jalaliConfigExtension };
  _selectedDate: Moment;
  lastDate: Date;
  get selectedDate(): Moment {
    if (
      this.name &&
      this.group?.controls &&
      this.group?.controls[this.name] &&
      this.group?.controls[this.name].value &&
      this.lastDate !== this.group?.controls[this.name].value
    ) {
      this.lastDate = this.group?.controls[this.name].value;
      this._selectedDate = moment(this.group?.controls[this.name].value.toString()).locale("fa");
    }
    return this._selectedDate;
  }
  set selectedDate(value: Moment) {
    this._selectedDate = value;
  }
  ngAfterViewChecked() {
    super.ngAfterViewChecked();
    this.renderer.setStyle(this.elRef.nativeElement.querySelector(".dp-input-container"), "height", this.defaultHeight + "px");
  }

  ngOnInit() {
    super.ngOnInit();
    this.config.format = "YYYY/MM/DD";
  }
  change(newValue: any) {
    if (newValue) {
      var _dateValue = moment.from(newValue, "fa", "YYYY/MM/DD HH:mm:ss").format("YYYY/MM/DD HH:mm:ss") as any;
      const datetime = new Date(_dateValue);
      datetime.setHours(12, 0, 0);
      new Date(this.group?.controls[this.name].value).setHours(12, 0, 0);
      if (new Date(this.group?.controls[this.name].value).getTime() !== datetime.getTime()) {
        this.group?.controls[this.name].setValue(datetime);
        this.group?.controls[this.name].markAsDirty();
      } else if (this.group?.controls[this.name].dirty) this.group?.controls[this.name].markAsPristine();
    } else {
      this.group?.controls[this.name].setValue(newValue);
    }
    super.onChange(newValue);
  }
}
